//public pages
import Login from "../pages/Login";
import Logout from "../pages/Logout";
import ForgotPassword from "../pages/ForgotPassword";

//private pages
import Jobs from "../pages/Dashboard/pages/Jobs";
import Reports from "../pages/Dashboard/pages/Reports";
import Ratings from "../pages/Dashboard/pages/Ratings";
import Users from "../pages/Dashboard/pages/Users";
import Places from "../pages/Dashboard/pages/Places";
import Professions from "../pages/Dashboard/pages/Professions";
import Skills from "../pages/Dashboard/pages/Skills";
import Workers from "../pages/Dashboard/pages/Workers";
import Chat from "../pages/Dashboard/pages/Chat";
import { ROLES } from "../utils/constans";
import EmailConfirmation from "../pages/EmailConfirmation";
import ResetPassword from "../pages/ResetPassword";
// import Settings from "../pages/Dashboard/pages/Settings";

export const paths = {
    home: '/',
    login: '/logowanie',
    logout: '/wyloguj',
    forgotPassword: '/zapomnialem-hasla',
    resetPassword: '/resetuj-haslo',
    emailConfirmation: '/email-potwierdzenie',
    jobs: '/zlecenia',
    jobsActive: '/zlecenia/aktywne',
    jobsCompleted: '/zlecenia/zakonczone',
    reports: '/raporty',
    ratings: '/oceny',
    users: '/uzytkownicy',
    places: '/obiekty',
    professions: '/zawody',
    skills: '/umiejetnosci',
    workers: '/pracownicy',
    settings: '/ustawienia',
    chat: '/chat'
}

const routesMain = {
    login: {
        path: paths.login,
        to: paths.login,
        name: 'Logowanie',
        component: Login
    },
    logout: {
        path: paths.logout,
        to: paths.logout,
        name: 'Wyloguj się',
        component: Logout,
        icon: "logout"
    },
    forgotPassword: {
        path: paths.forgotPassword,
        to: paths.forgotPassword,
        name: 'Zapomniałem hasła',
        component: ForgotPassword
    },
    resetPassword: {
        path: paths.resetPassword,
        to: paths.resetPassword,
        name: 'Resetuj hasło',
        component: ResetPassword
    },
    emailConfirmation: {
        path: paths.emailConfirmation,
        to: paths.emailConfirmation,
        name: 'Potwierdzenie adresu email',
        component: EmailConfirmation
    }
};

const routesPrivate = {
    jobs: {
        path: `${paths.jobs}/:id`,
        to: paths.jobs,
        name: 'Zlecenia',
        component: Jobs,
        icon: "order"
    },
    reports: {
        path: paths.reports,
        to: paths.reports,
        name: 'Raporty',
        component: Reports,
        icon: "report"
    },
    ratings: {
        path: paths.ratings,
        to: paths.ratings,
        name: 'Oceny',
        component: Ratings,
        icon: "star"
    },
    users: {
        path: paths.users,
        to: paths.users,
        name: 'Użytkownicy',
        component: Users,
        icon: "user-circle"
    },
    places: {
        path: paths.places,
        to: paths.places,
        name: 'Obiekty',
        component: Places,
        icon: "object"
    },
    professions: {
        path: paths.professions,
        to: paths.professions,
        name: 'Zawody',
        component: Professions,
        icon: "proffesion"
    },
    skills: {
        path: paths.skills,
        to: paths.skills,
        name: 'Umiejętności',
        component: Skills,
        icon: "skill"
    },
    workers: {
        path: paths.workers,
        to: paths.workers,
        name: 'Pracownicy',
        component: Workers,
        icon: "workers"
    },
    // settings: {
    //     path: paths.settings,
    //     to: paths.settings,
    //     name: 'Ustawienia',
    //     component: Settings,
    //     icon: "settings"
    // },
    chat: {
        exact: true,
        path: [paths.chat, `${paths.chat}/:id`],
        to: paths.chat,
        name: 'Chat',
        component: Chat,
        hideSidebar: true
    }
}

export const getRoutesMain = () => {
    return {
        ...routesMain
    }
};

export const getRoutesDashboard = role => {
    switch (role) {
        case ROLES.SUPERADMIN:
            return {
                ...routesPrivate
            };
        case ROLES.ADMINISTRATOR:
            return {
                jobs: routesPrivate.jobs,
                reports: routesPrivate.reports,
                ratings: routesPrivate.ratings,
                users: routesPrivate.users,
                places: routesPrivate.places
            }
        case ROLES.MANAGER:
            return {
                jobs: routesPrivate.jobs,
                reports: routesPrivate.reports,
                ratings: routesPrivate.ratings,
            }
        default:
            return {
                jobs: routesPrivate.jobs,
                reports: routesPrivate.reports,
                ratings: routesPrivate.ratings
            }
    }
};